angular.module("UI8.components").component("searchModal", {
  controllerAs: "ctrl",
  template: `<div class="srch">

    <div class="srch__field">
      <svg class="srch__field-icon" viewBox="0 0 24 24"><path d="M11 2a9 9 0 0 1 9 9 8.96 8.96 0 0 1-1.968 5.617l3.675 3.676a1 1 0 0 1-1.32 1.497l-.094-.083-3.676-3.675A8.96 8.96 0 0 1 11 20a9 9 0 1 1 0-18zm0 2a7 7 0 1 0 0 14c1.89 0 3.606-.749 4.865-1.967a.73.73 0 0 1 .077-.09l.09-.077C17.251 14.606 18 12.89 18 11a7 7 0 0 0-7-7z"/></svg>
      <input id="search-input" class="srch__field-input" type="search" placeholder="Search 12,000+ products, authors, categories…" autocomplete="off" maxlength="60" ng-model="$root.searchTerm" ng-change="ctrl.onSearchInput()" ng-keydown="ctrl.watchKeys($event)">
      <div class="srch__field-clear" ng-if="$root.searchTerm">
        {{$root.searchTerm}}
        <button ng-click="ctrl.clearSearchInput()">
          <svg viewBox="0 0 14 14"><path d="M1.988.585l.094.083L7 5.585 11.918.668a1 1 0 0 1 1.497 1.32l-.083.094L8.414 7l4.918 4.918a1 1 0 0 1-1.32 1.497l-.094-.083L7 8.414l-4.918 4.918a1 1 0 0 1-1.497-1.32l.083-.094L5.585 7 .668 2.082A1 1 0 0 1 1.886.515l.101.069z"></path></svg>
        </button>
      </div>
      <button class="srch__field-close" aria-label="Close search" ng-click="ctrl.closeSearch()">
        <svg viewBox="0 0 14 14"><path d="M1.988.585l.094.083L7 5.585 11.918.668a1 1 0 0 1 1.497 1.32l-.083.094L8.414 7l4.918 4.918a1 1 0 0 1-1.32 1.497l-.094-.083L7 8.414l-4.918 4.918a1 1 0 0 1-1.497-1.32l.083-.094L5.585 7 .668 2.082A1 1 0 0 1 1.886.515l.101.069z"/></svg>
      </button>
      <div class="fast" ng-if="ctrl.showFast && ctrl.recentSearches.length">
        <div class="fast__group">
          <div class="fast__label">Recent searches <button class="fast__clear" ng-click="ctrl.clearRecentSearches()">Clear</button></div>
          <a class="fast__item" ng-repeat="q in ctrl.recentSearches" ng-click="ctrl.applyRecentSearch(q)">
            <span class="fast__icon">
              <svg viewBox="0 0 16 16"><path d="M8 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zm.5 3a.5.5 0 0 0-1 0v3.7l2.65 1.5a.5.5 0 1 0 .5-.87l-2.15-1.22V4.5z" fill="currentColor"/></svg>
            </span>
            <span class="fast__name">{{q}}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="srch__main">
      <aside class="srch__sidebar" id="sidebar">
        <div class="s-filters" ng-class="{'collapsed': ctrl.collapsed.category}" data-group="category">
          <div class="s-filters__head" ng-click="ctrl.toggleCollapse('category')">
            <span class="s-filters__label">Category</span>
            <svg class="s-filters__caret" viewBox="0 0 16 16"><path fill="currentColor" d="M3.22 5.97a.75.75 0 0 1 1.06 0L8 9.69l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 7.03a.75.75 0 0 1 0-1.06Z"></path></svg>
          </div>
          <div class="s-filters__body">
            <div class="s-filters__option" ng-class="{'checked': it.selected}" ng-repeat="it in ctrl.filters.categories.items" ng-click="ctrl.toggleFilter(it.slug)">
              <span class="s-filters__box"><svg viewBox="0 0 10 10"><path d="M2 5l2 2 4-4" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></span>
              <span class="s-filters__name">{{it.altName || it.name}}</span>
              <span class="s-filters__count">{{it.count}}</span>
            </div>
          </div>
        </div>
        <div class="s-filters" ng-if="ctrl.hasVisibleCompatibilities()" ng-class="{'collapsed': ctrl.collapsed.software}" data-group="software">
          <div class="s-filters__head" ng-click="ctrl.toggleCollapse('software')">
            <span class="s-filters__label">Platform</span>
            <svg class="s-filters__caret" viewBox="0 0 16 16"><path fill="currentColor" d="M3.22 5.97a.75.75 0 0 1 1.06 0L8 9.69l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 7.03a.75.75 0 0 1 0-1.06Z"></path></svg>
          </div>
          <div class="s-filters__body">
            <div class="s-filters__option" ng-if="it.count !== 0" ng-class="{'checked': it.selected}" ng-repeat="it in ctrl.visibleCompatibilities()" ng-click="ctrl.toggleFilter(it.slug)">
              <span class="s-filters__box"><svg viewBox="0 0 10 10"><path d="M2 5l2 2 4-4" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></span>
              <span class="s-filters__icon" ng-if="it.imageUrl">
                <img ng-src="{{it.imageUrl}}" alt="{{it.name}}" />
              </span>
              <span class="s-filters__name">{{it.altName || it.name}}</span>
              <span class="s-filters__count">{{it.count}}</span>
            </div>
          </div>
        </div>
        <div class="s-filters" ng-if="ctrl.popularTags.length && ctrl.selectedCategoryCount() <= 1" ng-class="{'collapsed': ctrl.collapsed.tags}" data-group="tags">
          <div class="s-filters__head" ng-click="ctrl.toggleCollapse('tags')">
            <span class="s-filters__label">Tags</span>
            <svg class="s-filters__caret" viewBox="0 0 16 16"><path fill="currentColor" d="M3.22 5.97a.75.75 0 0 1 1.06 0L8 9.69l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 7.03a.75.75 0 0 1 0-1.06Z"></path></svg>
          </div>
          <div class="s-filters__body">
            <div class="s-filters__option" ng-if="it.count !== 0" ng-class="{'checked': ctrl.selectedTags[it.slug]}" ng-repeat="it in ctrl.popularTags" ng-click="ctrl.toggleTag(it.slug)">
              <span class="s-filters__box"><svg viewBox="0 0 10 10"><path d="M2 5l2 2 4-4" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></span>
              <span class="s-filters__name">{{it.slug}}</span>
              <span class="s-filters__count">{{it.count}}</span>
            </div>
          </div>
        </div>
        <div class="s-filters" ng-class="{'collapsed': ctrl.collapsed.price}" data-group="price">
          <div class="s-filters__head" ng-click="ctrl.toggleCollapse('price')">
            <span class="s-filters__label">Price</span>
            <svg class="s-filters__caret" viewBox="0 0 16 16"><path fill="currentColor" d="M3.22 5.97a.75.75 0 0 1 1.06 0L8 9.69l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 7.03a.75.75 0 0 1 0-1.06Z"></path></svg>
          </div>
          <div class="s-filters__body">
            <div class="range">
              <div class="range__row">
                <span class="range__val">\${{ctrl.state.priceMin}}</span>
                <div class="range__track">
                  <div class="range__fill" ng-style="ctrl.fillStyle()"></div>
                  <input class="range__input" type="range" min="5" max="99" ng-model="ctrl.state.priceMin" ng-model-options="{ updateOn: 'input' }" ng-change="ctrl.clampMin()" step="1">
                  <input class="range__input" type="range" min="5" max="99" ng-model="ctrl.state.priceMax" ng-model-options="{ updateOn: 'input' }" ng-change="ctrl.clampMax()" step="1">
                </div>
                <span class="range__val range__val--max">\${{ctrl.state.priceMax}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="s-filters" ng-class="{'collapsed': ctrl.collapsed.following}" data-group="following">
          <div class="s-filters__head" ng-click="ctrl.toggleCollapse('following')">
            <span class="s-filters__label">Following</span>
            <svg class="s-filters__caret" viewBox="0 0 16 16"><path fill="currentColor" d="M3.22 5.97a.75.75 0 0 1 1.06 0L8 9.69l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 7.03a.75.75 0 0 1 0-1.06Z"></path></svg>
          </div>
          <div class="s-filters__body">
            <div class="s-filters__empty" ng-if="!ctrl.followedAuthors.length">Authors you follow will appear here.</div>
            <div class="s-filters__option" ng-if="it.count > 0" ng-class="{'checked': ctrl.selectedAuthors[it._id]}" ng-repeat="it in ctrl.followedAuthors" ng-click="ctrl.toggleAuthorFilter(it._id)">
              <span class="s-filters__box"><svg viewBox="0 0 10 10"><path d="M2 5l2 2 4-4" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></span>
              <span class="s-filters__name">{{it.display_name || it.first_name}}</span>
              <span class="s-filters__count" ng-if="it.count || it.productCount">{{it.count || it.productCount}}</span>
            </div>
          </div>
        </div>
      </aside>

      <main class="srch__content">
        <div class="srch__meta" ng-if="ctrl.hasQuery">
          <div class="srch__chips">
            <button
              ng-repeat="chip in ctrl.chipsList"
              ng-class="{'active': ctrl.chips[chip.key]}"
              ng-click="ctrl.toggleChip(chip.key)"
              data-chip="{{chip.key}}">
              <span class="dot" ng-if="chip.dot"></span>
              {{chip.label}}
              <span class="counter" ng-if="chip.countKey && ctrl.activeFiltersList.length">{{ctrl.chipCounts[chip.countKey]}}</span>
            </button>
          </div>
          <div class="srch__chips">
            <div class="srch__select" ng-click="$event.stopPropagation()">
              <button ng-class="{'current': ctrl.sortOpen}" ng-click="ctrl.sortOpen = !ctrl.sortOpen">
                {{ctrl.currentSortLabel()}}
                <svg viewBox="0 0 16 16"><path d="M3.22 5.97a.75.75 0 0 1 1.06 0L8 9.69l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 7.03a.75.75 0 0 1 0-1.06Z"></path></svg>
              </button>
              <div class="srch__dropdown" ng-class="{'visible': ctrl.sortOpen}">
                <button ng-repeat="opt in ctrl.sortOptions" ng-class="{'current': $root.sortFilter === opt.value}" ng-click="ctrl.selectSort(opt.value)">{{opt.label}}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="srch__selected" ng-if="ctrl.hasQuery && (ctrl.activeFiltersList.length || ctrl.isPriceFiltered())">
          <button ng-repeat="f in ctrl.activeFiltersList" ng-click="ctrl.removeFilter(f.slug, f.isAuthor, f.isTag)">
            {{f.altName || f.name}}
            <svg viewBox="0 0 14 14"><path d="M1.988.585l.094.083L7 5.585 11.918.668a1 1 0 0 1 1.497 1.32l-.083.094L8.414 7l4.918 4.918a1 1 0 0 1-1.32 1.497l-.094-.083L7 8.414l-4.918 4.918a1 1 0 0 1-1.497-1.32l.083-.094L5.585 7 .668 2.082A1 1 0 0 1 1.886.515l.101.069z"></path></svg>
          </button>
          <button ng-if="ctrl.isPriceFiltered()" ng-click="ctrl.clearPriceFilter()">
            \${{ctrl.state.priceMin}} – \${{ctrl.state.priceMax}}
            <svg viewBox="0 0 14 14"><path d="M1.988.585l.094.083L7 5.585 11.918.668a1 1 0 0 1 1.497 1.32l-.083.094L8.414 7l4.918 4.918a1 1 0 0 1-1.32 1.497l-.094-.083L7 8.414l-4.918 4.918a1 1 0 0 1-1.497-1.32l.083-.094L5.585 7 .668 2.082A1 1 0 0 1 1.886.515l.101.069z"></path></svg>
          </button>
          <button ng-click="ctrl.clearAllFilters()">Clear all filters</button>
          <div class="srch__counter"><b>{{ctrl.totalCount}}</b> results</div>
        </div>
        
        <div class="srch__catalog" ng-if="ctrl.hasQuery && ctrl.hasResults">
          <product-card drawer="true" drawer-active="ctrl.drawerProduct && ctrl.drawerProduct._id === product._id" on-drawer-open="ctrl.openDrawer(product)" ng-repeat="product in ctrl.products track by product._id" product="product" user="ctrl.user"></product-card>
        </div>

        <div class="loader" ng-if="(ctrl.hasQuery && (ctrl.searching || !ctrl.disabled)) || ctrl.loadingDefaultSections" ui8-lazy-load when-visible="ctrl.loadMore()" container="ctrl.container"></div>

        <div class="srch__section" ng-if="!ctrl.hasQuery && !ctrl.loadingDefaultSections && ctrl.trendingSearches.length">
          <div class="srch__head">
            <h2>
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12L6 8l3 3 5-7"></path><path d="M10 4h4v4"></path></svg>
              Trending searches
            </h2>
          </div>
          <div class="srch__buttons">
            <button ng-repeat="q in ctrl.trendingSearches" ng-click="ctrl.applyTrendingSearch(q)">{{q}}</button>
          </div>
        </div>

        <div class="srch__section" ng-if="!ctrl.hasQuery && !ctrl.loadingDefaultSections && ctrl.browsingHistory.length">
          <div class="srch__head">
            <h2>
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6"></circle><path d="M8 4.5v3.5l2.25 1.5"></path></svg>
              Continue browsing
            </h2>
            <button ng-click="ctrl.clearBrowsingHistory()">Clear</button>
          </div>
          <div class="srch__catalog is-default">
            <product-card drawer="true" drawer-active="ctrl.drawerProduct && ctrl.drawerProduct._id === product._id" on-drawer-open="ctrl.openDrawer(product)" ng-repeat="product in ctrl.browsingHistory track by product._id" product="product" user="ctrl.user"></product-card>
          </div>
        </div>

        <div class="srch__section" ng-if="!ctrl.hasQuery && ctrl.featuredSection.products.length">
          <div class="srch__head">
            <h2>
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2l1.8 3.6 4 .6-2.9 2.8.7 4L8 11.2l-3.6 1.8.7-4L2.2 6.2l4-.6L8 2z"></path></svg>
              Recently featured
            </h2>
          </div>
          <div class="srch__catalog is-default">
            <product-card drawer="true" drawer-active="ctrl.drawerProduct && ctrl.drawerProduct._id === product._id" on-drawer-open="ctrl.openDrawer(product)" ng-repeat="product in ctrl.featuredSection.products track by product._id" product="product" user="ctrl.user"></product-card>
          </div>
        </div>

        <div class="srch__section" ng-if="!ctrl.hasQuery && ctrl.releasedSection.products.length">
          <div class="srch__head">
            <h2>
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 1.5l1.5 4.5L14 7.5l-4.5 1.5L8 13.5l-1.5-4.5L2 7.5l4.5-1.5L8 1.5z"></path></svg>
              Just released
            </h2>
          </div>
          <div class="srch__catalog is-default">
            <product-card drawer="true" drawer-active="ctrl.drawerProduct && ctrl.drawerProduct._id === product._id" on-drawer-open="ctrl.openDrawer(product)" ng-repeat="product in ctrl.releasedSection.products track by product._id" product="product" user="ctrl.user"></product-card>
          </div>
        </div>

        <div class="srch__section" ng-if="!ctrl.hasQuery && ctrl.popularSection.products.length">
          <div class="srch__head">
            <h2>
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 14c-3 0-5-2-5-4.5 0-1.5.8-2.6 1.8-3.3C5 7.5 6 8 6.5 7.5c.4-.4.2-1.3-.4-2.3C7 3.5 8 2 9 2c0 1.8 1 3 2 4 1 .9 2 2 2 3.5 0 2.5-2 4.5-5 4.5z"></path></svg>
              Popular this week
            </h2>
          </div>
          <div class="srch__catalog is-default">
            <product-card drawer="true" drawer-active="ctrl.drawerProduct && ctrl.drawerProduct._id === product._id" on-drawer-open="ctrl.openDrawer(product)" ng-repeat="product in ctrl.popularSection.products track by product._id" product="product" user="ctrl.user"></product-card>
          </div>
        </div>

        <div class="srch__empty" ng-if="ctrl.hasQuery && !ctrl.hasResults && !ctrl.searching">
          <svg viewBox="0 0 32 32" fill="currentColor"><path d="M14 2c6.6 0 12 5.4 12 12 0 2.7-.9 5.2-2.4 7.2l4.6 4.6c.5.5.5 1.3 0 1.8-.5.5-1.3.5-1.8 0L21.8 23c-2 1.5-4.5 2.4-7.2 2.4C7.4 25.4 2 20 2 13.4S7.4 2 14 2zm0 2.7C8.9 4.7 4.7 8.9 4.7 14s4.2 9.3 9.3 9.3 9.3-4.2 9.3-9.3S19.1 4.7 14 4.7z"></path></svg>
          <div class="srch__empty-title">No results</div>
          <div class="srch__empty-text">Try removing a filter or one of the related searches.</div>
          <button ng-click="ctrl.clearAllFilters()">Clear all filters</button>
        </div>
        
        <div class="srch__section srch__section--related" ng-if="ctrl.hasQuery && !ctrl.hasResults && !ctrl.searching && ctrl.relatedSearches.length">
          <div class="srch__head">
            <h2>
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="7" r="5"></circle><path d="M11 11l3 3"></path></svg>
              Related searches
            </h2>
          </div>
          <div class="srch__buttons">
            <button ng-repeat="q in ctrl.relatedSearches" ng-click="ctrl.applyRecentSearch(q)">{{q}}</button>
          </div>
        </div>
      </main>

      <button class="drawer-backdrop" ng-class="{'open': ctrl.drawerProduct}" ng-click="ctrl.closeDrawer()"></button>

      <aside class="drawer" ng-class="{'open': ctrl.drawerProduct}">
        <div class="drawer__scroll" ng-if="ctrl.drawerProduct">
          <div class="drawer__hero">
            <img ng-src="{{ctrl.drawerImage}}" alt="{{ctrl.drawerProduct.name}}" ui8-fade-in>
          </div>
          <div class="drawer__body">
            <div class="drawer__title-row">
              <h2 class="drawer__title">
                <a ng-href="{{ctrl.drawerProductLink()}}" ng-click="ctrl.leaveSearch()">{{ctrl.drawerProduct.name}}</a>
              </h2>
              <div class="drawer__price" ng-if="ctrl.drawerProduct.price">
                <span class="drawer__price-full" ng-if="ctrl.drawerProduct.seasonal_promo_enabled && ctrl.drawerProduct.site_promo">{{ctrl.drawerProduct.price | ui8Currency}}</span>
                <span>{{(ctrl.drawerProduct.seasonal_promo_enabled && ctrl.drawerProduct.site_promo ? ctrl.drawerProduct.seasonal_promo_price : ctrl.drawerProduct.price) | ui8Currency}}</span>
              </div>
              <span class="drawer__price" ng-if="!ctrl.drawerProduct.price">Free</span>
            </div>
            <a class="drawer__author" ng-if="ctrl.drawerProduct.author" ng-href="/{{ctrl.drawerProduct.author.display_name_slug || ctrl.drawerProduct.author._id}}/products" ng-click="ctrl.leaveSearch()">
              <img ng-src="{{ctrl.drawerProduct.author.avatar_url}}" alt="{{ctrl.drawerProduct.author.display_name || ctrl.drawerProduct.author.first_name}}">
              <span>{{ctrl.drawerProduct.author.display_name || ctrl.drawerProduct.author.first_name}}</span>
            </a>
            <div class="drawer__desc" ng-if="ctrl.drawerProduct.description">
              <p>{{ctrl.drawerProduct.description}}</p>
            </div>
            <div class="drawer__meta">
              <div ng-if="ctrl.drawerProduct.category && ctrl.drawerProduct.category.length">
                <div class="drawer__meta-label">Category</div>
                <div class="drawer__meta-row">
                  <a class="drawer__meta-value drawer__meta-value--link" ng-href="/categories/{{ctrl.drawerProduct.category[0].slug}}" ng-click="ctrl.leaveSearch()">{{ctrl.drawerProduct.category[0].name}}</a>
                </div>
              </div>
              <div ng-if="ctrl.drawerProduct.compatibilityItems && ctrl.drawerProduct.compatibilityItems.length">
                <div class="drawer__meta-label">Platform</div>
                <div class="drawer__meta-row drawer__meta-row--icons">
                  <span class="drawer__meta-icon" ng-repeat="c in ctrl.drawerProduct.compatibilityItems" data-tip="{{c.name}}">
                    <img ng-src="{{c.imageUrl}}" alt="{{c.name}}">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer__footer" ng-if="ctrl.drawerProduct">
          <a class="new-btn new-btn--secondary" ng-href="{{ctrl.drawerProductLink()}}" ng-click="ctrl.leaveSearch()">Full view</a>
          <button class="new-btn" ng-if="(!ctrl.user || !ctrl.user.pass_holder) && ctrl.drawerProduct.price && !ctrl.drawerProduct.freebie" data-partial="angular_card" data-id="{{ctrl.drawerProduct.base_subscription_id || ctrl.drawerProduct._id}}" ng-click="ctrl.addToCart($event)">Add to cart</button>
          <button class="new-btn new-btn--tertiary" ng-if="ctrl.user && (ctrl.user.pass_holder || ctrl.userHasLifetime) && (ctrl.drawerProduct | ui8Deliverables) && ctrl.drawerProduct.price" ng-disabled="ctrl.downloadLoading" ng-click="ctrl.toggleDownloadModal()">{{ctrl.downloadLoading ? 'Loading…' : 'Download'}}</button>
          <button class="new-btn new-btn--tertiary" ng-if="ctrl.user && (ctrl.drawerProduct | ui8Deliverables) && !ctrl.drawerProduct.price" ng-disabled="ctrl.downloadLoading" ng-click="ctrl.toggleDownloadModal()">{{ctrl.downloadLoading ? 'Loading…' : 'Download'}}</button>
          <a class="new-btn new-btn--tertiary" ng-if="!ctrl.user && (ctrl.drawerProduct | ui8Deliverables) && !ctrl.drawerProduct.price" href="/account/signup" ng-click="ctrl.closeSearch()">Download</a>
          <button class="new-btn new-btn--like" ng-if="ctrl.user" ng-class="{active: ctrl.isLiked(ctrl.drawerProduct._id)}" ng-click="ctrl.toggleLike(ctrl.drawerProduct._id)"><span>{{ctrl.likeCount(ctrl.drawerProduct._id, ctrl.drawerProduct.likes)}}</span><svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
          <a class="new-btn new-btn--like" ng-if="!ctrl.user" href="/account/signup" ng-click="ctrl.closeSearch()"><span>{{ctrl.drawerProduct.likes || 0}}</span><svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
        </div>
      </aside>
    </div>
  </div>
  <download-modal ng-if="ctrl.showDownloadModal" product="ctrl.drawerProduct" display="ctrl.showDownloadModal" freebie="ctrl.drawerProduct.freebie || !ctrl.drawerProduct.price"></download-modal>
  <div class="alerts alerts--bottom fadeIn" ng-if="ctrl.cartToast"><span ng-if="!ctrl.cartToastIsError">{{ctrl.cartToast}} <span>added to cart</span></span><span ng-if="ctrl.cartToastIsError">{{ctrl.cartToast}}</span><button class="new-btn new-btn--secondary" ng-if="!ctrl.cartToastIsError" ng-click="ctrl.viewCart()">View cart</button></div>`,

  controller: function (
    $rootScope,
    $location,
    $http,
    $q,
    $window,
    $timeout,
    ProductService,
    LikeService,
    CartService
  ) {
    var ctrl = this;
    var requestNumber = 0;

    // How many results were loaded when the user left via a drawer link —
    // the first page-0 search refetches that many in one request so the
    // grid is tall enough for the saved scroll position to land.
    var restoreCount = parseInt(
      sessionStorage.getItem("count:search") || 0,
      10
    );
    sessionStorage.removeItem("count:search");

    // ── Utilities ─────────────────────────────────────────────────────────────
    function debounce(fn, delay) {
      var timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }

    // Search opens on Recent. A sort the visitor picks themselves is
    // remembered (sortPicked); the default is not, so changing it later
    // isn't pinned by every visitor's saved state.
    var DEFAULT_SORT = "recent";

    function updateSortFilter(val) {
      $rootScope.sortFilter = val || DEFAULT_SORT;
    }

    var SEARCH_STATE_KEY = "srch:search-state";

    function saveSearchState() {
      try {
        localStorage.setItem(
          SEARCH_STATE_KEY,
          JSON.stringify({
            searchTerm: $rootScope.searchTerm || "",
            sortFilter: $rootScope.sortFilter || DEFAULT_SORT,
            sortPicked: !!ctrl.sortPicked,
            selectedFilters: ctrl.selectedFilters,
            selectedTags: ctrl.selectedTags,
            selectedAuthors: ctrl.selectedAuthors,
            chips: ctrl.chips,
            priceMin: ctrl.state.priceMin,
            priceMax: ctrl.state.priceMax,
          })
        );
      } catch (e) {
        console.error("Error saving search state", e);
      }
    }

    function loadSearchState() {
      try {
        var saved = JSON.parse(localStorage.getItem(SEARCH_STATE_KEY));
        if (!saved) return;
        $rootScope.searchTerm = saved.searchTerm || "";
        // States saved before sortPicked existed all carry the old
        // "popular" default, so they fall back to the new default too
        ctrl.sortPicked = !!saved.sortPicked;
        $rootScope.sortFilter =
          (ctrl.sortPicked && saved.sortFilter) || DEFAULT_SORT;
        ctrl.selectedFilters = saved.selectedFilters || {};
        ctrl.selectedTags = saved.selectedTags || {};
        ctrl.selectedAuthors = saved.selectedAuthors || {};
        ctrl.chips = angular.extend(
          {
            free: false,
            new: false,
            under25: false,
            featured: false,
            hasDesignDna: false,
            sale: false,
          },
          saved.chips || {}
        );
        ctrl.state.priceMin =
          saved.priceMin != null ? Math.max(saved.priceMin, 5) : 5;
        ctrl.state.priceMax = saved.priceMax != null ? saved.priceMax : 99;
        // A saved Sale toggle must not survive the sale ending
        if (!(window.UI8 && window.UI8.currentSale)) ctrl.chips.sale = false;
        Object.keys(ctrl.filters).forEach(function (key) {
          ctrl.filters[key].items.forEach(function (item) {
            item.selected = !!ctrl.selectedFilters[item.slug];
          });
        });
        rebuildActiveFiltersList();
      } catch (e) {
        console.error("Error loading search state", e);
      }
    }

    // ── State ─────────────────────────────────────────────────────────────────
    ctrl.state = { priceMin: 5, priceMax: 99 };
    ctrl.collapsed = {};

    ctrl.filters = {
      categories: {
        type: "category",
        items: [
          { name: "UI Kits", slug: "ui-kits" },
          { name: "Coded Templates", slug: "coded-templates" },
          { name: "No Code", slug: "no-code" },
          { name: "Illustrations", slug: "illustrations" },
          { name: "Fonts", slug: "fonts" },
          { name: "Wireframe Kits", slug: "wireframe-kits" },
          { name: "Presentation", slug: "presentation" },
          { name: "Mockups", slug: "mockups" },
          { name: "3D Assets", slug: "3d-assets" },
          { name: "Icons", slug: "icons" },
          { name: "Themes", slug: "themes" },
        ],
      },
      compatibilities: {
        type: "compatibility",
        items: [],
      },
    };

    ctrl.filters.compatibilities.items = (
      ($window.UI8 && $window.UI8.searchCompabilities) ||
      []
    ).map(function (c) {
      return {
        slug: c.name
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^a-z0-9-]/g, ""),
        name: c.name,
        imageUrl: c.imageUrl,
        kind: c.kind === "format" ? "format" : "tool",
        categories: c.categories || [],
      };
    });
    // Tools A-Z first, file formats A-Z last (same order as the category dropdown)
    ctrl.filters.compatibilities.items.sort(function (a, b) {
      if (a.kind !== b.kind) return a.kind === "tool" ? -1 : 1;
      return a.name.localeCompare(b.name);
    });

    ctrl.drawerProduct = null;

    ctrl.selectedFilters = {};
    ctrl.selectedTags = {};
    ctrl.popularTags = [];
    ctrl.selectedAuthors = {};
    ctrl.followedAuthors = [];
    ctrl.activeFiltersList = [];

    ctrl.chips = {
      free: false,
      new: false,
      under25: false,
      featured: false,
      hasDesignDna: false,
      sale: false,
    };
    ctrl.chipCounts = { free: 0, featured: 0, hasDesignDna: 0, sale: 0 };
    ctrl.chipsList = [
      { key: "under25", label: "Under $25" },
      { key: "featured", label: "Featured", countKey: "featured" },
      { key: "hasDesignDna", label: "AI-Ready", countKey: "hasDesignDna" },
    ];
    // Sale filter only exists while a seasonal sale is running
    if (window.UI8 && window.UI8.currentSale) {
      ctrl.chipsList.push({ key: "sale", label: "Sale", countKey: "sale" });
    }

    ctrl.sortOpen = false;
    ctrl.sortOptions = [
      { value: "popular", label: "Popular" },
      { value: "recent", label: "Recent" },
      { value: "high", label: "Highest price" },
      { value: "low", label: "Lowest price" },
    ];

    ctrl.featuredSection = { products: [] };
    ctrl.releasedSection = { products: [] };
    ctrl.popularSection = { products: [] };
    ctrl.trendingSearches = [];
    ctrl.relatedSearches = [];
    ctrl.loadingDefaultSections = true;

    var BROWSING_KEY = "srch:browsing-history";
    ctrl.browsingHistory = (function () {
      try {
        return JSON.parse(localStorage.getItem(BROWSING_KEY)) || [];
      } catch (e) {
        return [];
      }
    })();

    ctrl.userToken = (function () {
      if ($window.UI8 && $window.UI8.loggedIn)
        return "user-" + $window.UI8.loggedIn;
      var anon = localStorage.getItem("srch:anon-token");
      if (!anon) {
        anon =
          "anon-" +
          Math.random().toString(36).slice(2) +
          Date.now().toString(36);
        try {
          localStorage.setItem("srch:anon-token", anon);
        } catch (e) {
          console.error("Error saving anonymous token", e);
        }
      }
      return anon;
    })();

    ctrl.products = [];
    ctrl.hasResults = false;
    ctrl.hasQuery = false;
    ctrl.searching = false;
    ctrl.loadingMore = false;
    ctrl.disabled = false;
    ctrl.page = 0;
    ctrl.showFast = false;
    ctrl.queryID = null;
    ctrl.queryIndex = null;

    var RECENT_SEARCHES_KEY = "srch:recent-searches";
    // "free" is a filter chip, not a search: never remember it (and drop it
    // from what an older visit stored).
    function unfitRecentSearch(q) {
      return /(^|[^a-z0-9])free([^a-z0-9]|$)/i.test(q);
    }
    ctrl.recentSearches = (function () {
      try {
        return (JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY)) || []).filter(
          function (q) {
            return !unfitRecentSearch(q);
          }
        );
      } catch (e) {
        return [];
      }
    })();

    ctrl.clearSearchInput = function () {
      $rootScope.searchTerm = "";
      saveSearchState();
      runSearch(0);
    };

    ctrl.applyRecentSearch = function (q) {
      $rootScope.searchTerm = q;
      ctrl.showFast = false;
      runSearch(0);
    };

    ctrl.clearRecentSearches = function () {
      ctrl.recentSearches = [];
      localStorage.removeItem(RECENT_SEARCHES_KEY);
    };

    function saveRecentSearch(term) {
      if (!term || !term.trim() || unfitRecentSearch(term)) return;
      ctrl.recentSearches = ctrl.recentSearches.filter(function (q) {
        return q !== term;
      });
      ctrl.recentSearches.unshift(term);
      if (ctrl.recentSearches.length > 8)
        ctrl.recentSearches = ctrl.recentSearches.slice(0, 8);
      try {
        localStorage.setItem(
          RECENT_SEARCHES_KEY,
          JSON.stringify(ctrl.recentSearches)
        );
      } catch (e) {
        console.error("Error saving recent search", e);
      }
    }

    var debouncedPriceSearch = debounce(function () {
      runSearch(0);
    }, 400);

    // ── Private functions ─────────────────────────────────────────────────────
    function updateFacetCounts(facets) {
      if (!facets) return;
      var catFacets = facets["category.slug"] || {};
      var compFacets = facets["compatibility"] || {};
      Object.keys(ctrl.filters).forEach(function (key) {
        var group = ctrl.filters[key];
        group.items.forEach(function (item) {
          if (group.type === "category") item.count = catFacets[item.slug] || 0;
          else if (group.type === "compatibility")
            item.count = compFacets[item.name] || 0;
        });
      });
      ctrl.chipCounts = {
        free: (facets.freebie && facets.freebie["true"]) || 0,
        featured: (facets.featured && facets.featured["true"]) || 0,
        hasDesignDna: (facets.hasDesignDna && facets.hasDesignDna["true"]) || 0,
        sale: (facets.site_promo && facets.site_promo["true"]) || 0,
      };
      var authorFacets = facets["author._id"] || {};
      ctrl.followedAuthors.forEach(function (author) {
        author.count = authorFacets[author._id] || 0;
      });

      var tagFacets = facets["tags.slug"] || {};
      ctrl.popularTags = Object.keys(tagFacets)
        .map(function (slug) {
          return { slug: slug, count: tagFacets[slug] };
        })
        .sort(function (a, b) {
          return b.count - a.count;
        })
        .slice(0, 10);
    }

    function rebuildActiveFiltersList() {
      ctrl.activeFiltersList = [];
      Object.keys(ctrl.filters).forEach(function (key) {
        ctrl.filters[key].items.forEach(function (item) {
          if (ctrl.selectedFilters[item.slug])
            ctrl.activeFiltersList.push(item);
        });
      });
      Object.keys(ctrl.selectedTags).forEach(function (slug) {
        if (ctrl.selectedTags[slug])
          ctrl.activeFiltersList.push({ slug: slug, name: slug, isTag: true });
      });
      ctrl.followedAuthors.forEach(function (author) {
        if (ctrl.selectedAuthors[author._id])
          ctrl.activeFiltersList.push({
            slug: author._id,
            name: author.display_name || author.first_name,
            isAuthor: true,
          });
      });
    }

    function loadDefaultSections() {
      var limit = getColumnCount() * 2;
      var empty = function () {
        return { data: { products: [] } };
      };
      $q.all([
        $http
          .get("/api/products", {
            params: {
              sort: "recent",
              featured: true,
              count: limit,
              exclude_subscription_product: true,
              include_description: true,
            },
          })
          .catch(empty),
        $http
          .get("/api/products", {
            params: {
              sort: "recent",
              count: limit,
              exclude_subscription_product: true,
              include_description: true,
            },
          })
          .catch(empty),
        $http
          .get("/api/popular-this-week", { params: { limit: limit } })
          .catch(empty),
        $http
          .get("/api/trending-searches", { params: { limit: 10 } })
          .catch(function () {
            return { data: { queries: [] } };
          }),
      ]).then(function (results) {
        ctrl.featuredSection.products = results[0].data.products || [];
        ctrl.releasedSection.products = results[1].data.products || [];
        ctrl.popularSection.products = results[2].data.products || [];
        ctrl.trendingSearches = results[3].data.queries || [];
        ctrl.loadingDefaultSections = false;
      });
    }

    function loadFollowing() {
      var key = ctrl.user && (ctrl.user.display_name_slug || ctrl.user._id);
      if (!key) return;
      $http
        .get("/api/users/" + key + "/following", {
          params: { count: 100 },
        })
        .then(function (res) {
          ctrl.followedAuthors = res.data || [];
          rebuildActiveFiltersList();
        })
        .catch(function () {});
    }

    function getColumnCount() {
      var gap = 24;
      var minColWidth = 314;
      var containerWidth =
        $(".srch__catalog").width() || $(".srch__content").width() || 0;
      return Math.max(
        1,
        Math.floor((containerWidth + gap) / (minColWidth + gap))
      );
    }

    function computeLimit() {
      var cols = getColumnCount();
      return cols * Math.ceil(20 / cols);
    }

    function buildQuery(page, limit) {
      var query = {
        search: $rootScope.searchTerm,
        sort: $rootScope.sortFilter,
        page: page,
        limit: limit,
        userToken: ctrl.userToken,
      };

      if (ctrl.chips.free) query.freebie = true;
      if (ctrl.chips.under25) query.under25 = true;
      if (ctrl.chips.featured) query.featured = true;
      if (ctrl.chips.hasDesignDna) query.hasDesignDna = true;
      if (ctrl.chips.sale) query.seasonal_sale = true;
      if (ctrl.state.priceMin > 5) query.price_min = ctrl.state.priceMin;
      if (ctrl.state.priceMax < 99) query.price_max = ctrl.state.priceMax;

      var activeCats = [];
      var activeCompats = [];
      Object.keys(ctrl.selectedFilters).forEach(function (slug) {
        if (!ctrl.selectedFilters[slug]) return;
        Object.keys(ctrl.filters).forEach(function (key) {
          var group = ctrl.filters[key];
          var item = group.items.find(function (i) {
            return i.slug === slug;
          });
          if (!item) return;
          if (group.type === "category") activeCats.push(slug);
          else if (group.type === "compatibility")
            activeCompats.push(item.name);
        });
      });
      if (activeCats.length) query.cats = activeCats.join(",");
      if (activeCompats.length)
        query.compatibility_names = activeCompats.join(",");

      var activeTags = Object.keys(ctrl.selectedTags).filter(function (s) {
        return ctrl.selectedTags[s];
      });
      if (activeTags.length) query.tags = activeTags.join(",");

      var activeAuthorIds = Object.keys(ctrl.selectedAuthors).filter(function (
        id
      ) {
        return ctrl.selectedAuthors[id];
      });
      if (activeAuthorIds.length) query.author_ids = activeAuthorIds.join(",");

      return query;
    }

    function topUp() {
      var cols = getColumnCount();
      if (
        ctrl.products.length % cols === 0 ||
        ctrl.disabled ||
        !ctrl.hasQuery ||
        ctrl.searching
      )
        return;

      var limit = computeLimit();
      var page = Math.floor(ctrl.products.length / limit);
      var existingIds = {};
      ctrl.products.forEach(function (p) {
        existingIds[p._id] = true;
      });

      ctrl.disabled = true;
      ProductService.search(buildQuery(page, limit))
        .then(function (response) {
          var items = (response.products || []).filter(function (p) {
            return !existingIds[p._id];
          });
          ctrl.products = ctrl.products.concat(items);
          ctrl.page = page;
          ctrl.disabled = ctrl.totalCount <= ctrl.products.length;
        })
        .catch(angular.noop);
    }

    function runSearch(page) {
      var currentReq = ++requestNumber;
      ctrl.page = page;
      ctrl.hasQuery =
        !!($rootScope.searchTerm || "").trim() ||
        ctrl.activeFiltersList.length > 0 ||
        ctrl.state.priceMin > 5 ||
        ctrl.state.priceMax < 99;

      if (!ctrl.hasQuery) {
        ctrl.searching = false;
        ctrl.disabled = false;
        ctrl.products = [];
        if (page === 0) {
          saveSearchState();
          ProductService.search({
            search: "",
            sort: $rootScope.sortFilter || DEFAULT_SORT,
            page: 0,
            facets_only: true,
          })
            .then(function (res) {
              updateFacetCounts(res.facets);
            })
            .catch(angular.noop);
        }
        return;
      }

      ctrl.searching = true;
      ctrl.disabled = true;
      if (page === 0) {
        ctrl.products = [];
        // Keep previous chip counts until fresh facets arrive — zeroing
        // here made the numbers flash 0 on every toggle
        ctrl.queryID = null;
        ctrl.queryIndex = null;
        saveSearchState();
      }

      var base = computeLimit();
      var limit = base;
      if (page === 0 && restoreCount > base) {
        // Round up to a multiple of the page size so the next loadMore
        // page continues at the right offset.
        limit = Math.min(Math.ceil(restoreCount / base) * base, 500);
      }
      if (page === 0) restoreCount = 0;
      var query = buildQuery(page, limit);

      return ProductService.search(query)
        .then(function (response) {
          if (requestNumber !== currentReq) return;
          ctrl.products = ctrl.products.concat(response.products || []);
          if (page === 0 && limit > base) ctrl.page = limit / base - 1;
          if (page === 0 && response.queryID) {
            ctrl.queryID = response.queryID;
            ctrl.queryIndex = response.index || null;
          }
          ctrl.totalCount = response.totalCount || 0;
          ctrl.hasResults = !!ctrl.totalCount;
          ctrl.disabled = ctrl.totalCount <= ctrl.products.length;
          if (page === 0 && ctrl.totalCount > 0)
            saveRecentSearch(($rootScope.searchTerm || "").trim());
          if (
            page === 0 &&
            !ctrl.totalCount &&
            ($rootScope.searchTerm || "").trim()
          ) {
            var term = ($rootScope.searchTerm || "").trim();
            $http
              .get("/api/trending-searches", { params: { q: term, limit: 10 } })
              .then(function (res) {
                ctrl.relatedSearches = res.data.queries || [];
              })
              .catch(function () {
                ctrl.relatedSearches = [];
              });
          } else if (page === 0) {
            ctrl.relatedSearches = [];
          }
          updateFacetCounts(response.facets);
          if (page === 0)
            setTimeout(function () {
              var top = parseInt(sessionStorage.getItem("top:search") || 0, 10);
              sessionStorage.removeItem("top:search");
              var el = document.querySelector(".srch__content");
              if (el) el.scrollTop = top;
            }, 0);
        })
        .catch(function () {
          console.error("Search error");
        })
        .finally(function () {
          ctrl.searching = false;
          ctrl.loadingMore = false;
        });
    }

    // ── Public methods ────────────────────────────────────────────────────────
    ctrl.drawerProductLink = function () {
      if (!ctrl.drawerProduct) return "#";
      var author = ctrl.drawerProduct.author;
      var slug = author && (author.display_name_slug || author._id);
      return "/" + slug + "/products/" + ctrl.drawerProduct.slug;
    };

    ctrl.openDrawer = function (product) {
      // Same 604x420 webp URL product-card computes for the grid, so the
      // drawer image is served straight from the browser cache instead of
      // re-downloading the full-size original of the same picture.
      if (product.has_resized_card_image) {
        var imgPostfix = product.card_image_version
          ? "_" + product.card_image_version
          : "";
        ctrl.drawerImage =
          "https://images.ui8.net/product/" +
          product._id +
          "/604_420" +
          imgPostfix +
          ".webp";
      } else {
        ctrl.drawerImage = product.card_image;
      }
      var allCompats = ($window.UI8 && $window.UI8.allCompabilities) || [];
      product.compatibilityItems = (product.compatibility || [])
        .map(function (name) {
          var found = allCompats.find(function (c) {
            return c.name === name;
          });
          return found ? { name: name, imageUrl: found.imageUrl } : null;
        })
        .filter(Boolean);
      ctrl.drawerProduct = product;
      ctrl.showDownloadModal = false;

      if (ctrl.queryID && (product.objectID || product._id)) {
        var pos = ctrl.products.indexOf(product);
        if (pos !== -1) {
          $http
            .post("/api/search/click", {
              queryID: ctrl.queryID,
              objectID: product.objectID || product._id,
              position: pos + 1,
              userToken: ctrl.userToken,
              index: ctrl.queryIndex,
            })
            .catch(angular.noop);
        }
      }

      ctrl.browsingHistory = ctrl.browsingHistory.filter(function (p) {
        return p._id !== product._id;
      });
      ctrl.browsingHistory.unshift(product);
      if (ctrl.browsingHistory.length > 8)
        ctrl.browsingHistory = ctrl.browsingHistory.slice(0, 8);
      try {
        localStorage.setItem(
          BROWSING_KEY,
          JSON.stringify(ctrl.browsingHistory)
        );
      } catch (e) {
        console.error("Error saving browsing history", e);
      }
    };

    ctrl.closeDrawer = function () {
      ctrl.drawerProduct = null;
    };

    ctrl.clearBrowsingHistory = function () {
      ctrl.browsingHistory = [];
      localStorage.removeItem(BROWSING_KEY);
    };

    ctrl.isLiked = LikeService.isLiked;
    ctrl.getCountModifier = LikeService.getCountModifier;
    ctrl.likeCount = LikeService.likeCount;
    ctrl.toggleLike = function (id) {
      LikeService.toggleLike(id);
    };

    ctrl.cartToast = null;
    ctrl.cartToastIsError = false;
    var cartToastTimer = null;

    ctrl.showCartToast = function (message, isError) {
      ctrl.cartToast = message;
      ctrl.cartToastIsError = !!isError;
      if (cartToastTimer) $timeout.cancel(cartToastTimer);
      cartToastTimer = $timeout(function () {
        ctrl.cartToast = null;
        ctrl.cartToastIsError = false;
      }, 50000);
    };

    ctrl.viewCart = function () {
      if (cartToastTimer) $timeout.cancel(cartToastTimer);
      ctrl.cartToast = null;
      ctrl.cartToastIsError = false;
      ctrl.closeSearch();
      $timeout(function () {
        $(".header__cell--cart .header__head").trigger("click");
      }, 0);
    };

    function truncateName(name) {
      return name && name.length > 32 ? name.substr(0, 32) + "..." : name;
    }

    ctrl.addToCart = function (e) {
      var name = ctrl.drawerProduct ? ctrl.drawerProduct.name : "";
      CartService.addToCart(e, function (err) {
        ctrl.showCartToast(err || truncateName(name), !!err);
      });
    };

    $rootScope.$on("search:cart-added", function (_, data) {
      ctrl.showCartToast(
        data.isError ? data.message : truncateName(data.name),
        data.isError
      );
    });

    ctrl.showDownloadModal = false;
    ctrl.downloadLoading = false;
    ctrl.toggleDownloadModal = function () {
      if (ctrl.showDownloadModal) {
        ctrl.showDownloadModal = false;
        return;
      }
      if (ctrl.drawerProduct.files) {
        ctrl.showDownloadModal = true;
        return;
      }
      ctrl.downloadLoading = true;
      $http
        .get("/api" + ctrl.drawerProductLink())
        .then(function (res) {
          var product = res.data && res.data.data && res.data.data.product;
          if (product) ctrl.drawerProduct.files = product.files || [];
          ctrl.showDownloadModal = true;
        })
        .catch(function () {
          ctrl.showDownloadModal = true;
        })
        .finally(function () {
          ctrl.downloadLoading = false;
        });
    };

    ctrl.toggleCollapse = function (group) {
      ctrl.collapsed[group] = !ctrl.collapsed[group];
    };

    ctrl.clampMin = function () {
      ctrl.state.priceMin = parseInt(ctrl.state.priceMin);
      if (ctrl.state.priceMin >= ctrl.state.priceMax)
        ctrl.state.priceMin = ctrl.state.priceMax - 1;
      debouncedPriceSearch();
    };
    ctrl.clampMax = function () {
      ctrl.state.priceMax = parseInt(ctrl.state.priceMax);
      if (ctrl.state.priceMax <= ctrl.state.priceMin)
        ctrl.state.priceMax = ctrl.state.priceMin + 1;
      debouncedPriceSearch();
    };
    ctrl.fillStyle = function () {
      var minPct = ((ctrl.state.priceMin - 5) / 94) * 100;
      var maxPct = ((ctrl.state.priceMax - 5) / 94) * 100;
      return { left: minPct + "%", right: 100 - maxPct + "%" };
    };

    ctrl.toggleFilter = function (slug) {
      if (ctrl.selectedFilters[slug]) {
        delete ctrl.selectedFilters[slug];
      } else {
        ctrl.selectedFilters[slug] = true;
      }
      Object.keys(ctrl.filters).forEach(function (key) {
        ctrl.filters[key].items.forEach(function (item) {
          if (item.slug === slug) item.selected = ctrl.selectedFilters[slug];
        });
      });
      rebuildActiveFiltersList();
      runSearch(0);
    };

    ctrl.toggleAuthorFilter = function (authorId) {
      if (ctrl.selectedAuthors[authorId]) {
        delete ctrl.selectedAuthors[authorId];
      } else {
        ctrl.selectedAuthors[authorId] = true;
      }
      rebuildActiveFiltersList();
      runSearch(0);
    };

    ctrl.toggleTag = function (slug) {
      if (ctrl.selectedTags[slug]) {
        delete ctrl.selectedTags[slug];
      } else {
        ctrl.selectedTags[slug] = true;
      }
      rebuildActiveFiltersList();
      runSearch(0);
    };

    ctrl.removeFilter = function (slug, isAuthor, isTag) {
      if (isAuthor) {
        ctrl.selectedAuthors[slug] = false;
        rebuildActiveFiltersList();
        runSearch(0);
      } else if (isTag) {
        ctrl.selectedTags[slug] = false;
        rebuildActiveFiltersList();
        runSearch(0);
      } else {
        ctrl.toggleFilter(slug);
      }
    };

    ctrl.clearAllFilters = function () {
      ctrl.selectedFilters = {};
      ctrl.selectedTags = {};
      ctrl.popularTags = [];
      ctrl.selectedAuthors = {};
      Object.keys(ctrl.filters).forEach(function (key) {
        ctrl.filters[key].items.forEach(function (item) {
          item.selected = false;
        });
      });
      ctrl.chips = {
        free: false,
        new: false,
        under25: false,
        featured: false,
        hasDesignDna: false,
      };
      ctrl.state = { priceMin: 5, priceMax: 99 };
      $rootScope.searchTerm = "";
      rebuildActiveFiltersList();
      saveSearchState();
      runSearch(0);
    };

    ctrl.selectedCategoryCount = function () {
      return ctrl.filters.categories.items.filter(function (item) {
        return ctrl.selectedFilters[item.slug];
      }).length;
    };

    // Hide the whole Platform block when nothing in it would render
    ctrl.hasVisibleCompatibilities = function () {
      return ctrl.visibleCompatibilities().some(function (it) {
        return it.count !== 0;
      });
    };

    ctrl.visibleCompatibilities = function () {
      var activeCatSlugs = ctrl.filters.categories.items
        .filter(function (item) {
          return ctrl.selectedFilters[item.slug];
        })
        .map(function (item) {
          return item.slug;
        });

      if (!activeCatSlugs.length) return ctrl.filters.compatibilities.items;

      return ctrl.filters.compatibilities.items.filter(function (compat) {
        return (compat.categories || []).some(function (slug) {
          return activeCatSlugs.indexOf(slug) !== -1;
        });
      });
    };

    ctrl.isPriceFiltered = function () {
      return ctrl.state.priceMin > 5 || ctrl.state.priceMax < 99;
    };

    ctrl.clearPriceFilter = function () {
      ctrl.state.priceMin = 5;
      ctrl.state.priceMax = 99;
      runSearch(0);
    };

    ctrl.toggleChip = function (chip) {
      ctrl.chips[chip] = !ctrl.chips[chip];
      runSearch(0);
    };

    ctrl.currentSortLabel = function () {
      var opt = ctrl.sortOptions.find(function (o) {
        return o.value === $rootScope.sortFilter;
      });
      return opt ? opt.label : "Sort";
    };
    ctrl.selectSort = function (value) {
      ctrl.sortOpen = false;
      ctrl.sortPicked = true;
      updateSortFilter(value);
      runSearch(0);
    };

    ctrl.applyTrendingSearch = function (q) {
      $rootScope.searchTerm = q;
      runSearch(0);
    };
    ctrl.loadMore = function () {
      if (ctrl.searching || !ctrl.hasQuery) return;
      ctrl.loadingMore = true;
      runSearch(ctrl.page + 1);
    };
    ctrl.onSearchInput = debounce(function () {
      ctrl.showFast = false;
      runSearch(0);
    }, 500);
    ctrl.watchKeys = function (e) {
      if (e.keyCode === 27) ctrl.closeSearch();
    };
    ctrl.closeSearch = function () {
      $rootScope.showSearch = false;
      $location.search("search", null);
      // Non-SPA pages decouple $location from the real URL; app.js
      // listens for this and strips ?search=1 natively.
      $rootScope.$emit("search:closed");
      $("body").css("overflow-y", "scroll");
    };

    // For links that leave the page: save the scroll state so Back can
    // restore the search (?search=1 stays in the history entry). The
    // overlay is deliberately NOT hidden here: on a full-page navigation
    // that flashed the page underneath for as long as the next document
    // took to arrive. In-app transitions on SPA pages hide it themselves
    // (app_spa.js, $transitions.onStart) so the new state is not covered.
    ctrl.leaveSearch = function () {
      var el = document.querySelector(".srch__content");
      if (el) sessionStorage.setItem("top:search", el.scrollTop);
      sessionStorage.setItem("count:search", ctrl.products.length);
    };

    ctrl.$onChanges = function (changes) {
      if (changes.user && changes.user.currentValue) {
        loadFollowing();
      }
    };

    // ── Init ──────────────────────────────────────────────────────────────────
    ctrl.$onInit = function () {
      ctrl.user = $rootScope.user;
      ctrl.userHasLifetime = $window.UI8 && $window.UI8.userHasLifetime;
      if (ctrl.user) loadFollowing();
      ctrl.container = $(".srch__content");
      var $searchInput = $("#search-input");
      if ($(window).width() < 768)
        $searchInput.attr("placeholder", "Type to search...");

      loadSearchState();
      if (!$rootScope.sortFilter) $rootScope.sortFilter = DEFAULT_SORT;

      $searchInput.focus();
      loadDefaultSections();

      runSearch(0);

      var lastColCount = getColumnCount();
      $(window).on(
        "resize.srchDensity",
        debounce(function () {
          var cols = getColumnCount();
          if (cols !== lastColCount) {
            lastColCount = cols;
            if (ctrl.hasQuery) {
              topUp();
            } else {
              loadDefaultSections();
            }
          }
        }, 400)
      );

      $searchInput.on("focus", function () {
        if (
          ctrl.recentSearches.length &&
          !($rootScope.searchTerm || "").trim()
        ) {
          ctrl.showFast = true;
          $rootScope.$apply();
        }
      });

      $searchInput.on("blur", function () {
        setTimeout(function () {
          ctrl.showFast = false;
          $rootScope.$apply();
        }, 150);
      });

      function onDocClick() {
        if (ctrl.sortOpen) {
          ctrl.sortOpen = false;
          $rootScope.$apply();
        }
      }
      document.addEventListener("click", onDocClick);
      ctrl.$onDestroy = function () {
        document.removeEventListener("click", onDocClick);
        $searchInput.off("focus blur");
        $(window).off("resize.srchDensity");
      };
    };
  },

  bindings: { user: "<" },
});
